import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { PageCard } from '../../components/layout/page/PageCard';
import { fetchMyTeams, ProfileTeamMembership } from '../../services/myCollaboratorApi';

export function MyTeamsSection() {
  const [loading, setLoading] = useState(true);
  const [teams, setTeams] = useState<ProfileTeamMembership[]>([]);

  useEffect(() => {
    void (async () => {
      setLoading(true);
      try {
        setTeams(await fetchMyTeams());
      } catch {
        toast.error('Falha ao carregar suas equipes.');
        setTeams([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <p className="text-secondary-500">Carregando equipes...</p>;
  }

  return (
    <PageCard
      title="Equipes"
      subtitle="Equipes das quais você participa (não são grupos de permissão)."
    >
      {teams.length === 0 ? (
        <p className="text-sm text-secondary-500">
          Você ainda não está vinculado a nenhuma equipe.
        </p>
      ) : (
        <div className="overflow-x-auto">
          <table className="erp-table">
            <thead>
              <tr>
                <th>Equipe</th>
                <th>Papel</th>
                <th>Gestor imediato</th>
              </tr>
            </thead>
            <tbody>
              {teams.map((team) => (
                <tr key={team.teamId}>
                  <td>
                    <div className="font-medium text-secondary-900">{team.teamName}</div>
                    {team.teamDescription ? (
                      <div className="text-sm text-secondary-500">{team.teamDescription}</div>
                    ) : null}
                  </td>
                  <td>{team.isLeader ? 'Líder' : 'Membro'}</td>
                  <td>{team.bossUserName || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </PageCard>
  );
}
